import styles from './ScenariosView.module.css';
import { useEffect, useState } from 'react';
import ScenarioElement from './components/ScenarioElement';
import FileUpload from '../../shared/FileUpload';
import { scenarioService } from '../../features/Scenario/scenarioService';

const ScenarioPanel = () =>
{
	const [scenarios, setScenarios] = useState<string[]>([]);

	useEffect(() =>
	{
		loadScenarios();
	}, []);

	const loadScenarios = async () =>
	{
		try
		{
			const data = await scenarioService.fetch();
			setScenarios(data);
		}
		catch (error)
		{
			console.error('Failed to fetch scenarios:', error);
		}
	};

	const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) =>
	{
		const files = event.target.files;

		if (!files) return;

		Array.from(files).forEach(file =>
		{
			scenarioService.upload(file)
				.then(() =>
				{
					console.log(`File ${file.name} uploaded successfully`);
					loadScenarios();
				})
				.catch(error =>
				{
					console.error(`Failed to upload ${file.name}:`, error);
				});
		});

		event.target.value = '';
	};

	return (
		<div className={styles.container}>
			<div className={styles.actions}>
				<FileUpload label="Upload scenario" onChange={handleUpload} accept='.pbo' multiple compact />
				<p>These scenarios will be available on all servers</p>
			</div>
			<div className={styles.list}>
				{!scenarios.length && <div className={styles.emptyNotice}>No scenarios available</div>}
				{scenarios.map((scenario) => (
					<ScenarioElement key={scenario} name={scenario} onDelete={loadScenarios} />
				))}
			</div>
		</div>
	);
};

export default ScenarioPanel;